/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as TalosRouteImport } from './routes/talos'
import { Route as IrisRouteImport } from './routes/iris'
import { Route as CronosRouteImport } from './routes/cronos'
import { Route as AtlasRouteImport } from './routes/atlas'
import { Route as IndexRouteImport } from './routes/index'

const TalosRoute = TalosRouteImport.update({
  id: '/talos/$',
  path: '/talos/$',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IrisRoute = IrisRouteImport.update({
  id: '/iris/$',
  path: '/iris/$',
  getParentRoute: () => rootRouteImport,
} as any)
const CronosRoute = CronosRouteImport.update({
  id: '/cronos/$',
  path: '/cronos/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AtlasRoute = AtlasRouteImport.update({
  id: '/atlas/$',
  path: '/atlas/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/atlas/$': typeof AtlasRoute
  '/cronos/$': typeof CronosRoute
  '/iris/$': typeof IrisRoute
  '/talos/$': typeof TalosRoute
  '/login': typeof LoginRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/atlas/$': typeof AtlasRoute
  '/cronos/$': typeof CronosRoute
  '/iris/$': typeof IrisRoute
  '/talos/$': typeof TalosRoute
  '/login': typeof LoginRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/atlas/$': typeof AtlasRoute
  '/cronos/$': typeof CronosRoute
  '/iris/$': typeof IrisRoute
  '/talos/$': typeof TalosRoute
  '/login': typeof LoginRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/atlas/$' | '/cronos/$' | '/iris/$' | '/talos/$' | '/login'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/atlas/$' | '/cronos/$' | '/iris/$' | '/talos/$' | '/login'
  id: '__root__' | '/' | '/atlas/$' | '/cronos/$' | '/iris/$' | '/talos/$' | '/login'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AtlasRoute: typeof AtlasRoute
  CronosRoute: typeof CronosRoute
  IrisRoute: typeof IrisRoute
  TalosRoute: typeof TalosRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cronos/$': {
      id: '/cronos/$'
      path: '/cronos/$'
      fullPath: '/cronos/$'
      preLoaderRoute: typeof CronosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iris/$': {
      id: '/iris/$'
      path: '/iris/$'
      fullPath: '/iris/$'
      preLoaderRoute: typeof IrisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/talos/$': {
      id: '/talos/$'
      path: '/talos/$'
      fullPath: '/talos/$'
      preLoaderRoute: typeof TalosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/atlas/$': {
      id: '/atlas/$'
      path: '/atlas/$'
      fullPath: '/atlas/$'
      preLoaderRoute: typeof AtlasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AtlasRoute: AtlasRoute,
  CronosRoute: CronosRoute,
  IrisRoute: IrisRoute,
  TalosRoute: TalosRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>()
